(function () {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  const previewLinks = document.querySelectorAll('[data-collection-menu-preview]');

  if (!previewLinks.length) {
    return;
  }

  const preview = document.createElement('div');
  preview.className = 'navmenu-collection-preview';
  preview.hidden = true;
  preview.innerHTML = [
    '<img class="navmenu-collection-preview__image" alt="">',
    '<span class="navmenu-collection-preview__title"></span>',
  ].join('');

  document.body.appendChild(preview);

  const previewImage = preview.querySelector('.navmenu-collection-preview__image');
  const previewTitle = preview.querySelector('.navmenu-collection-preview__title');
  let activeLink = null;

  function positionPreview(link) {
    const menu = link.closest('.navmenu-depth-2');
    const linkRect = link.getBoundingClientRect();
    const menuRect = menu ? menu.getBoundingClientRect() : linkRect;
    const previewWidth = preview.offsetWidth || 240;
    const previewHeight = preview.offsetHeight || 290;
    const gap = 14;

    let left = menuRect.right + gap;
    const maxLeft = window.innerWidth - previewWidth - 16;

    if (left > maxLeft) {
      left = Math.max(16, menuRect.left - previewWidth - gap);
    }

    const idealTop = linkRect.top - 10;
    const maxTop = window.innerHeight - previewHeight - 16;
    const top = Math.max(16, Math.min(idealTop, maxTop));

    preview.style.left = `${left}px`;
    preview.style.top = `${top}px`;
  }

  function showPreview(link) {
    if (!desktopQuery.matches) {
      return;
    }

    const imageUrl = link.dataset.collectionMenuPreviewImage;

    if (!imageUrl) {
      return;
    }

    activeLink = link;
    previewImage.src = imageUrl;
    previewImage.alt = link.dataset.collectionMenuPreviewTitle || '';
    previewTitle.textContent = link.dataset.collectionMenuPreviewTitle || '';
    preview.hidden = false;
    positionPreview(link);
    preview.classList.add('is-visible');
  }

  function hidePreview() {
    activeLink = null;
    preview.classList.remove('is-visible');
    preview.hidden = true;
  }

  previewLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => showPreview(link));
    link.addEventListener('focus', () => showPreview(link));
    link.addEventListener('mouseleave', hidePreview);
    link.addEventListener('blur', hidePreview);
  });

  window.addEventListener('resize', () => {
    if (!desktopQuery.matches) {
      hidePreview();
      return;
    }

    if (activeLink) {
      positionPreview(activeLink);
    }
  });

  document.addEventListener('scroll', () => {
    if (activeLink) {
      positionPreview(activeLink);
    }
  }, true);
}());
